import styled from 'styled-components';
import { colors } from "colors";


export const HeaderWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  
  background-color: ${colors.white};
  padding: 16px 32px;
  
  span {
    padding: 8px;
  }
  
  div {
    display: flex;
    flex-flow: row wrap;
  }
  
  button {
    flex: 1;
    margin: 4px;
  }
`;

export const ButtonWrapper = styled.button`
  padding: 12px 32px;
  border-radius: 4px;
  background-color: transparent;
  border: solid 1px ${colors.brightBlue};

  color: ${colors.brightBlue};
  font-size: 14px;
  font-weight: bold;
  min-width: 256px;
  
  svg {
    fill: ${colors.brightBlue};
  }

  :hover {
    box-shadow: 2px 2px 4px ${colors.silver};
    cursor: pointer;
  }
`;

export const PartsHeaderWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  
  padding: 0 32px;
  color: ${colors.steel};
  background-color: ${colors.alabaster};
  border-bottom: 1px solid ${colors.paleGrey};
  font-size: 14px;
  font-weight: 600;

  span {
    flex: 1;
    padding: 16px 4px;
    min-width: 64px;
  }
  
  span:nth-child(1) {
    flex: 0.25;
    min-width: 32px;
    max-width: 32px;
  }
  
  span:nth-child(4) {
    flex: 0.5;
  }
  span:nth-child(5) {
    flex: 2;
  }
  span:nth-child(6) {
   flex: 0.75;
   text-align: end;
  }
  span:nth-child(7) {
    flex: 0.25;
  }
`;

export const PartsCostHeaderWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  
  padding: 0 32px;
  color: ${colors.slateGrey};
  background-color: ${colors.lightTan};
  font-size: 14px;

  span {
    flex: 1;
    padding: 16px 4px;
    min-width: 64px;
  }
  
  span:nth-child(1) {
    flex: 0.5;
  }
  
  span:nth-child(5) {
    flex: 2;
    font-weight: 600;
    text-align: end;
  }
`;


export const PartsCostWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  
  padding: 0 32px;
  color: ${colors.slateGrey};
  background-color: ${colors.white};
  font-size: 14px;

  div.container {
    flex: 1;
    padding: 8px 4px;
  }
  
  div.container {
    min-width: 64px;
  }
  
  div.container:nth-child(1) {
    flex: 0.5;
  }
  
  div.container:nth-child(5) {
    flex: 2;
    font-weight: 600;
    text-align: end;
  }
`;
